import script from "./RegisterFidelizacion.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterFidelizacion.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterFidelizacion.vue?vue&type=style&index=0&id=e00de5ae&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e00de5ae"]])

export default __exports__